/**
 * @author xyguo
 * @description 角色管理==》人员维护管理页面,展示该角色下所有人员信息
 * @Date 2020/1/2
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './columns'

import { framework_tool ,component_tool,utils_tool} from '@/tool'
let { WizContainer, WizReduxTemplate,modelUtils } = framework_tool;
let { WizCard,WizTabs} = component_tool;
let {Session} = utils_tool;
import RoleGroupList from '../roleGroup/roleGroupList'
import {color} from "echarts/src/export";

class RoleUserList extends WizContainer {

  componentName = 'RoleUserList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _onchange=(boardKey)=>{
    this.setState({boardKey:boardKey});
  }







  _render() {
    let record = this.props.location.record;
    let roleName = '';
    let roleId = '';
    if (record) {
      Session.set('roleRecord',record);
    }
    if (Session.get('roleRecord')){
      let roleRecord = Session.get('roleRecord');
      roleName = roleRecord.name;
      roleId = roleRecord.id;
    }
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:templateConfig({roleId}),
      roleId,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD
      },
    })
    let title = '当前角色:'+roleName;
    // let tips = "" ;
    // if(this.state.boardKey==2){
    //   tips = "温馨提示：已维护的用户组中新增的人员自动授予该角色" ;
    // }
    let tips = (<span style={{color:'#1890ff'}}>温馨提示：已维护的用户组中新增的人员自动授予该角色</span>);
    return <WizCard title={title} icon='0' >
    <WizTabs animated={false} defaultActiveKey="1" onChange={this._onchange} tabBarExtraContent={tips}>
        <WizTabs.TabPane tab="人员管理" key="1">
          <WizReduxTemplate {..._reduxTemplateCofig}
          />
        </WizTabs.TabPane>
        <WizTabs.TabPane tab="用户组维护" key="2">
          <RoleGroupList record={record}/>
        </WizTabs.TabPane>

      </WizTabs>
      </WizCard>



    // <WizCard title={title} icon='0' >

    //   <WizReduxTemplate {..._reduxTemplateCofig} />
    // </WizCard>



  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(RoleUserList);
